const dqzs = {
    namespaced: true,
    state: {
      name: 'dqzs',
      levelData: [{
          radio: '0',
          dw: 'μg/m3',
          value: '二氧化硫',
          type: 'So2',
          field: 'so2',
          lineColor: '#AD44A2',
          levels: [{
              num: 0,
              color: '#00E400',
              name: '优'
            },
            {
              num: 50,
              color: '#AAE004',
              name: '优'
            },
            {
              num: 150,
              color: '#FFFF00',
              name: '良'
            },
            {
              num: 500,
              color: '#FF7E00',
              name: '轻度污染'
            },
            {
              num: 650,
              color: '#FF0000',
              name: '中度污染'
            },
            {
              num: 800,
              color: '#99004C',
              name: '重度污染'
            },
            {
              num: 1600,
              color: '#7E0023',
              name: '严重污染'
            }
            // {num: 2100, color: "#42F47E", name: "严重污染"},
            // {num: 2620, color: "#1BF062", name: "严重污染"}
          ]
        },
        {
          radio: '1',
          dw: 'mg/m3',
          value: '一氧化碳',
          lineColor: '#26FFFF',
          yAxisIndex: 1,
          type: 'Co',
          field: 'co',
          levels: [{
              num: 0,
              color: '#00E400',
              name: '优'
            },
            {
              num: 5,
              color: '#FFFF00',
              name: '良'
            },
            {
              num: 10,
              color: '#FF7E00',
              name: '轻度污染'
            },
            {
              num: 35,
              color: '#FF0000',
              name: '中度污染'
            },
            {
              num: 60,
              color: '#99004C',
              name: '重度污染'
            },
            {
              num: 90,
              color: '#7E0023',
              name: '严重污染'
            }
            // {num: 120, color: "#AAA9A4", name: "严重污染"},
            // {num: 150, color: "#83817C", name: "严重污染"}
          ]
        },
        {
          radio: '2',
          dw: 'μg/m3',
          value: '二氧化氮',
          lineColor: '#E7B9A9',
          type: 'No2',
          field: 'no2',
          levels: [{
              num: 0,
              color: '#00E400',
              name: '优'
            },
            {
              num: 100,
              color: '#FFFF00',
              name: '良'
            },
            {
              num: 200,
              color: '#FF7E00',
              name: '轻度污染'
            },
            {
              num: 700,
              color: '#FF0000',
              name: '中度污染'
            },
            {
              num: 1200,
              color: '#99004C',
              name: '重度污染'
            },
            {
              num: 2340,
              color: '#7E0023',
              name: '严重污染'
            }
            // {num: 3090, color: "#FB7D3B", name: "严重污染"},
            // {num: 3840, color: "#F95A08", name: "严重污染"}
          ]
        },
        {
          radio: '3',
          dw: 'μg/m3',
          value: 'PM2.5',
          lineColor: '#FF2C2C',
          type: 'Pm25',
          field: 'pm25',
          levels: [{
              num: 0,
              color: '#00E400',
              name: '优'
            },
            {
              num: 35,
              color: '#FFFF00',
              name: '良'
            },
            {
              num: 75,
              color: '#FF7E00',
              name: '轻度污染'
            },
            {
              num: 115,
              color: '#FF0000',
              name: '中度污染'
            },
            {
              num: 150,
              color: '#99004C',
              name: '重度污染'
            },
            {
              num: 250,
              color: '#7E0023',
              name: '严重污染'
            }
            // {num: 350, color: "#781806", name: "严重污染"},
            // {num: 500, color: "#310901", name: "严重污染"}
          ]
        },
        {
          radio: '4',
          dw: 'μg/m3',
          value: 'PM10',
          lineColor: '#3FC677',
          type: 'Pm10',
          field: 'pm10',
          levels: [{
              num: 0,
              color: '#00E400',
              name: '优'
            },
            {
              num: 50,
              color: '#FFFF00',
              name: '良'
            },
            {
              num: 150,
              color: '#FF7E00',
              name: '轻度污染'
            },
            {
              num: 250,
              color: '#FF0000',
              name: '中度污染'
            },
            {
              num: 350,
              color: '#99004C',
              name: '重度污染'
            },
            {
              num: 420,
              color: '#7E0023',
              name: '严重污染'
            }
            // {num: 500, color: "#781806", name: "严重污染"},
            // {num: 600, color: "#310901", name: "严重污染"}
          ]
        },
        {
          radio: '5',
          dw: 'μg/m3',
          value: '臭氧',
          lineColor: '#FF0CFF',
          type: 'O3',
          field: 'o3',
          levels: [{
              num: 0,
              color: '#00E400',
              name: '优'
            },
            {
              num: 160,
              color: '#FFFF00',
              name: '良'
            },
            {
              num: 200,
              color: '#FF7E00',
              name: '轻度污染'
            },
            {
              num: 300,
              color: '#FF0000',
              name: '中度污染'
            },
            {
              num: 400,
              color: '#99004C',
              name: '重度污染'
            },
            {
              num: 800,
              color: '#7E0023',
              name: '严重污染'
            }
            // {num: 1000, color: "#CED465", name: "严重污染"},
            // {num: 1200, color: "#B3BB1B", name: "严重污染"}
          ]
        }
      ]
    },
    actions: {},
    mutations: {
      setLevelData (state, val) {
        state.levelData = val
      }
    }
}
export default dqzs



// WEBPACK FOOTER //
// ./src/store/modules/dqzs.js